import { PERMISSION_KEYS } from 'constants-permissions';

import { hasPermissionOrSuperUser } from 'lane-shared/helpers/hasPermission';
import type { UserType } from 'lane-shared/types/User';

import type { TemplatePermissions } from '../model/operations';

export function resolveTemplatePermissions(
  user: UserType | null,
  channelId: string,
  isReorderEnabled: boolean
): TemplatePermissions {
  if (!user || !channelId) {
    return { canManage: false, canReorder: false };
  }

  const canManage = hasPermissionOrSuperUser(
    user,
    [PERMISSION_KEYS.PERMISSION_INSPECTIONS_TEMPLATES_MANAGE],
    channelId
  );
  const hasReorderPermission = hasPermissionOrSuperUser(
    user,
    [PERMISSION_KEYS.PERMISSION_INSPECTIONS_TEMPLATES_REORDER],
    channelId
  );

  return { canManage, canReorder: isReorderEnabled && hasReorderPermission };
}
